// ---------------------------------------------------------------------------
// Runtime configuration. Values marked PLACEHOLDER must be filled in once the
// downstream Jotform application form exists and its embed origin is known.
// ---------------------------------------------------------------------------

/**
 * Endpoint the app fetches the premium table from. Served by the Cloudflare
 * Pages Function in `functions/api/premiums.ts`, which reads Cloudflare KV.
 * Relative so it works on any Pages/preview domain.
 */
export const PREMIUMS_API_PATH = "api/premiums";

/**
 * The Jotform application form, prefilled via query params on "Apply now".
 */
export const APPLICATION_FORM_URL = "https://form.jotform.com/261622415650047";

/**
 * Whether the prefill link should open in a new tab. True for now so the CTA
 * works before the Wix page is wired up. Once the Jotform is embedded on the
 * SAME Wix page (below the quote), switch to false and use the postMessage
 * route (the payload carries `prefillUrl` for the parent to load).
 */
export const OPEN_FORM_IN_NEW_TAB = true;

/**
 * PLACEHOLDER — target origin for postMessage to the Wix parent page.
 * Set to the exact Wix site origin (e.g. "https://www.agilityretail.co.za")
 * before go-live so the message can't be read by an unexpected embedder.
 * "*" is acceptable only during development.
 */
export const PARENT_ORIGIN = "*";

/**
 * Jotform field unique names used when building the prefill link (verified
 * against the live form on 2026-07-16):
 * - `optionSelection` — plan dropdown (options: Gap 200 … Ultra)
 * - `familySize`      — cover dropdown (options: "Individual", "Family (2+)")
 * - `DOB`             — date of birth; prefilled as DOB[day]/[month]/[year],
 *                       set to 1 January of (current year - age).
 */
export const JOTFORM_FIELDS = {
  plan: "optionSelection",
  familySize: "familySize",
  dob: "DOB",
} as const;

/** Message type namespaces used for parent <-> iframe postMessage. */
export const MESSAGE_TYPES = {
  apply: "gapco-quote:apply",
  height: "gapco-quote:height",
} as const;
